import fetch from './fetch'

export default {
    getOldTraffickingScreenings (payload) {
        const request = fetch({
            url: '/oldtraffickingscreening',
            method: 'get',
            payload
        })
        return request.call()
    },

    createOldTraffickingScreening (payload) {
        const request = fetch({
            url: '/oldtraffickingscreening',
            method: 'post',
            data: payload
        })

        return request.call()
    },

    updateOldTraffickingScreening (payload, screeningId) {
        const request = fetch({
            url: `/oldtraffickingscreening/${screeningId}`, // ??? Was: `/traffickingscreening/${screeningId}`
            method: 'patch',
            data: payload
        })

        return request.call()
    },

    downloadOldTraffickingScreening (payload) {
        const request = fetch({
            url: `/oldtraffickingscreening/download/${payload._id}`, //  `/traffickingscreening/download/${payload._id}`
            method: 'get',
            payload
        })

        return request.call()
    }
}



// WEBPACK FOOTER //
// ./src/api/oldTraffickingScreening.js